import { persistAppSession } from '../auth-utils';
import { AppUser } from './mapMsalAccount';

export function establishAppSession(user: AppUser, sessionExpiry: number, authProvider: string): void {
  persistAppSession(user, sessionExpiry, authProvider);
}
